import {ThemeType} from '@px/enum';
import {storageUtil} from '@px/helper/storage';

interface TradingViewStorage extends StorageObject {
  interval: string;
  settings: any;
}

export const STORAGE_KEY_CONTRACT = 'contract_tv';
export const STORAGE_KEY_SPOT = 'spot_tv';

export const tradingViewStorage = {
  readTradingViewStorage(key): TradingViewStorage {
    return storageUtil.readStorageObject(key, createInitTradingViewStorage());
  },
  readInterval(key): string {
    return tradingViewStorage.readTradingViewStorage(key).interval;
  },
  updateInterval(key, interval) {
    storageUtil.writeStorageObject(key, {...tradingViewStorage.readTradingViewStorage(key), interval});
  },
  readPriceType(key): string {
    return tradingViewStorage.readTradingViewStorage(key).priceType;
  },
  updatePriceType(key, priceType) {
    storageUtil.writeStorageObject(key, {...tradingViewStorage.readTradingViewStorage(key), priceType});
  },
  readIsInit(key): string {
    return tradingViewStorage.readTradingViewStorage(key).isInit;
  },
  updateIsInit(key, isInit) {
    storageUtil.writeStorageObject(key, {...tradingViewStorage.readTradingViewStorage(key), isInit});
  },
  readTheme(key): string {
    return tradingViewStorage.readTradingViewStorage(key).theme;
  },
  updateTheme(key, theme) {
    storageUtil.writeStorageObject(key, {...tradingViewStorage.readTradingViewStorage(key), theme});
  },
  readSettings(key): any {
    return tradingViewStorage.readTradingViewStorage(key).settings;
  },
  updateSettings(key, settings) {
    storageUtil.writeStorageObject(key, {...tradingViewStorage.readTradingViewStorage(key), settings});
  },
  readMAStudy(key): any {
    return tradingViewStorage.readTradingViewStorage(key).study;
  },
  updateMAStudy(key, study) {
    storageUtil.writeStorageObject(key, {...tradingViewStorage.readTradingViewStorage(key), study});
  },
};

function createInitTradingViewStorage(): TradingViewStorage {
  return {
    version: 1,
    isInit: true,
    theme: ThemeType.Dark,
    interval: '15',
    settings: null,
  };
}
